import React, {useEffect, useState, useRef} from "react";
import { Panel } from 'primereact/panel';
import { CardGroup, Form} from "react-bootstrap";
import style from "../Cart.module.css"
import {toNumber} from "lodash";
import {CartProduct} from "../../Product/CartProduct";
import InputGroup from "react-bootstrap/InputGroup";
import {Button} from "primereact/button";
import {useCartContext} from "../../../Context/CartContext";
import {CartProductNew} from "../../Product/CartProductNew/CartProductNew";
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {Tag} from "primereact/tag";

export const CartStockSetItem = ({stock, setItem, toast, isLoading, setIsLoading, discountLabel}) => {

    const [count, setCount] = useState(setItem.count);
    const {removeStockSetItemFromCart, updateStockSetItem} = useCartContext();
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();
    const timerRef = useRef(null);

    const incrementCount = () => {
        setCount(count + 1);
    }

    const decrementCount = () => {
        if (count > 1) {
            setCount(count - 1)
        }
    }

    const countHandler = (e) => {
        debugger
        if (e.target.value === "" || toNumber(e.target.value) === 0) {
            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Помилка',
                detail: 'Кількість не може бути менше 1',
                life: 1000
            });
            setCount(1)
        } else if (e.target.validity.valid && !(e.target.value === "" || e.target.value === undefined || isNaN(e.target.value))) {
            setCount(parseFloat(e.target.value))
        }
    }

    const updateSetItem = async () => {
        setIsLoading(true);
        updateStockSetItem(setItem, stock.Id, count).then(data => {
            setIsLoading(false);
                if (data.isSucccess) {
                    console.log('Cart updated')
                } else {
                    toast.current.clear();
                    toast.current.show({
                        severity: 'error',
                        summary: 'Помилка оновлення кошика',
                        detail: data.message,
                        life: 1000
                    });
                }
        })
    }

    const removeStockSetItemHandler = async(stockId, setId) => {
        debugger
        removeStockSetItemFromCart(stockId, setId).then((data) => {
            if (data.isSucccess) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Комплект видалено з кошика',
                    clearPrevious: true,
                    life: 1000
                });
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка',
                    clearPrevious: true,
                    detail: 'Помилка змінення кошика',
                    life: 1000
                });
            }
        })
    }

    useEffect(() => {

         if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        if (count) {
            // Запускаем таймер на 500 миллисекунд
            timerRef.current = setTimeout(() => {
                updateSetItem();
            }, 300);
        }

        // Очищаем таймер при размонтировании компонента
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [count])

    const headerPanelTemplate = (options, setItem) => {
        let headerStyle = {display:'grid', gridTemplateColumns:'1fr 5fr 1fr', gridGap:'20px'};
        let inputGroupStyle = {};

        if(viewPortWidth > 1000){
            inputGroupStyle = {width:'25%', height:'100%', justifySelf:'center', alignSelf:'center'};
        }
        if(viewPortWidth <= 1000 && viewPortWidth >= 500){
            inputGroupStyle = {width:'50%', height:'100%', justifySelf:'center', alignSelf:'center'}
        }
        if(viewPortWidth < 500){
            headerStyle = {display:'grid', gridTemplateColumns:'1fr 4fr 1fr', gridGap:'10px'};
            inputGroupStyle = {width:'60%', height:'100%', justifySelf:'center', alignSelf:'center'}
        }

        const className = `${options.className}`;
        const wrapperStyle = {display:'grid', gridTemplateRows: '30px 1fr', width:'100%',gridGap:'10px'};
        const footerStyle = {display:'grid'};

        return (
            <div className={`${className}`}>


                <div style={wrapperStyle}>
                    <div style={headerStyle}>
                        <Tag severity="info" value="Комплект" style={{alignSelf:'center', justifySelf:"start"}} rounded></Tag>
                        <div className='p-inputgroup cart-stock-set-custom-input' style={inputGroupStyle}>
                            <Button icon="pi pi-minus" onClick={decrementCount} rounded text raised
                                    style={{borderRadius: '10px 0px 0px 10px', height: '30px', background:'#fbce07', color:'#666666'}}></Button>
                            <Form.Control style={{textAlign: 'center', height: '30px', borderRadius:'0px'}} type="text" min={0}
                                          pattern="[0-9]*"
                                          value={count} onInput={countHandler}/>
                            <Button icon="pi pi-plus" onClick={incrementCount} rounded text raised
                                    style={{borderRadius: '0px 10px 10px 0px', height: '30px', background:'#fbce07', color:'#666666'}}></Button>
                        </div>
                            <Button icon="pi pi-times" label="" style={{borderRadius: '50%', alignSelf: 'end', justifySelf:'end'}} rounded
                                    severity="danger"
                                    className="p-button p-button-danger  p-button-text "
                                    onClick={() => removeStockSetItemHandler(stock.Id, setItem.id)}/>
                    </div>
                    <div style={footerStyle}>
                        <span style={{fontWeight: '600', alignSelf: 'center'}}>{setItem.name}</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Panel style={{marginTop: '10px'}} headerTemplate={(options) => headerPanelTemplate(options, setItem)}
               toggleable>
            <CardGroup className={style.cardGroup}>
                {
                    setItem.productList.map((p, index) => <CartProductNew
                        key={p.id + index}
                        id={p.id}
                        isSet={stock.IsSet}
                        stockId={stock.Id}
                        discountLabel={discountLabel}
                        name={p.name}
                        number={p.number}
                        recommendPrice={p.recommendPrice}
                        priceList={p.priceList}
                        calcPrice={p.calcPrice}
                        productPrice={p.productPrice}
                        productStockPrice={p.productStockPrice}
                        priceListIndex={p.priceListIndex}
                        count={p.count}
                        isDiscount={p.isDiscount}
                        isLoading={isLoading}
                        setIsLoading = {setIsLoading}
                        urls={p.smallImageUrlList}
                        isBalanceEnds={p.IsBalanceEnds}
                        toast={toast}
                    />
                )
            }
        </CardGroup>
    </Panel>
    )
}